<template>
  <v-container>
    <v-row 
      justify="center"
      align="center"
    >
      <v-col 
        cols="12"
        sm="12"
        md="10"
      >
        <v-card>
          <v-card-title>
            Commande {{ id }}
          </v-card-title>          
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="9"
              lg="8"
              class="pl-7"
            >
              <v-row
                align="center"
                justify="center"
              >
                <v-col>
                  <b>Statut Commande</b><br>
                  <v-skeleton-loader
                    :loading="isLoading"
                    width="150"
                    class="my-2"
                    type="chip"
                  >
                    <v-chip 
                      :color="statusColor" 
                      dark
                      class="fs12 my-2"
                      small
                    >{{ statusName }}</v-chip>
                  </v-skeleton-loader>
                </v-col>
                <v-col>
                  <b>Panier HT</b><br>
                  <v-skeleton-loader
                    :loading="isLoading"
                    width="100"
                    class="my-2"
                    type="chip"
                  >
                    <v-chip
                      color="primary"
                      class="fs12 my-1"
                      outlined
                      pill
                    >{{ etItemsTotal | toPrice(2, '€') }}</v-chip>
                  </v-skeleton-loader>
                </v-col>
                <v-col>
                  <b>Port HT</b><br>
                  <v-skeleton-loader
                    :loading="isLoading"
                    width="100"
                    class="my-2"
                    type="chip"
                  >
                    <v-chip
                      color="primary"
                      class="fs12 my-1"
                      outlined
                      pill
                    >{{ etShippingTotal | toPrice(2, '€') }}</v-chip>
                  </v-skeleton-loader>
                </v-col>
                <v-col v-if="discount > 0">
                  <b>Remise</b><br>
                  <v-skeleton-loader
                    :loading="isLoading"
                    width="100"
                    class="my-2"
                    type="chip"
                  >
                    <v-chip
                      color="primary"
                      class="fs12 my-1"
                      outlined
                      pill
                    >{{ discount | toPrice(2, '%') }}</v-chip>
                  </v-skeleton-loader>
                </v-col>
                <v-col>
                  <b>Total HT</b><br>
                  <v-skeleton-loader
                    :loading="isLoading"
                    width="100"
                    class="my-2"
                    type="chip"
                  >
                    <v-chip
                      color="primary"
                      class="fs12 my-1"
                      outlined
                      pill
                    >{{ etTotal | toPrice(2, '€') }}</v-chip>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                class="mb-2"
              >
                <v-col>
                  <b>
                    Date de livraison : 
                    <v-skeleton-loader
                      :loading="isLoading"
                      class="inline-block"
                      width="100"
                      height="30"
                      min-height="30"
                      type="text"
                    >{{ expectedDelivery }}</v-skeleton-loader>
                  </b>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row
                align="center"
                justify="center"
              >
                <v-col
                  cols="12"
                >
                  <Items 
                    v-if="!isLoading"
                    :items="order.items"
                  ></Items>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="3"
              lg="4"
            >

              <v-row
                align="center"
                justify="center"
              >
                <v-col class="pb-1">
                  <b>Historique Commande</b>
                </v-col>
              </v-row>
              <v-progress-linear
                indeterminate
                color="primary"
                :active="isLoading"
              ></v-progress-linear>
              <v-row
                align="center"
                justify="center"
                v-for="history in order.histories"
                :key="history.id"
                class="histories-items"
              >
                <v-col class="py-0">
                  <v-chip 
                    color="#008cba" 
                    dark
                    class="fs12 my-2"
                    small
                  >{{ history.date.formatted }}</v-chip>
                </v-col>
                <v-col>
                  <span>{{ history.status }}</span>
                </v-col>
              </v-row>

              <v-divider class="my-7"></v-divider>

              <v-row no-gutters>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  lg="6"
                >
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <v-col class="pb-1">
                      <b>Adresse de Livraison</b>
                    </v-col>
                  </v-row>
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    :active="isLoading"
                  ></v-progress-linear>
                  <Address 
                    :address="shippingAddress"
                    v-if="!isLoading"></Address>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  lg="6"
                >
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <v-col class="pb-1">
                      <span class="font-weight-bold">Adresse de Facturation</span>
                    </v-col>
                  </v-row>
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    :active="isLoading"
                  ></v-progress-linear>
                  <Address 
                    :address="billingAddress"
                    v-if="!isLoading"></Address>
                </v-col>                
              </v-row>

              <v-divider class="my-7"></v-divider>

              <v-row
                align="center"
                justify="center"
              >
                <v-col class="pb-1">
                  <b>Historique Livraison</b>
                </v-col>
              </v-row>
              <v-progress-linear
                indeterminate
                color="primary"
                :active="isLoading"
              ></v-progress-linear>
              <ShippingHistories :shippingHistories="order.shippingHistories"></ShippingHistories>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // COMPONENTS
  import Address from './Address'
  import Items from './Items'
  import ShippingHistories from './ShippingHistories'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { COMPARE_OLD_CART } from '@/store/actions/cart'
  import { LOADING, LOADED } from '@/store/actions/general'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory.js'
  const OrdersRepository = RepositoryFactory.get('orders')

  export default {
    name: 'Show',

    components: { 
      Address, 
      Items,
      ShippingHistories,
    },

    data: () => ({
      id: 0,
      isLoading: true,
      order: {},
      referer: null,
    }),

    methods: {
      async getOrder(id) {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await OrdersRepository
          .getOrder(id, customerApiToken)
          .then(response => {
            this.isLoading = false
            this.order    = response.data
            if (this.referer === 'checkout' && Object.prototype.hasOwnProperty.call(this.order, 'cartGuid')) {
              this.$store.dispatch(COMPARE_OLD_CART, {
                guid: this.order.cartGuid,
              })
            }
            EventBus.$emit(LOADED)
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      },
    },

    computed: {
      etItemsTotal() {
        if (this.order.etItemsTotal === null) {
          return 0
        }

        return this.order.etItemsTotal
      },
      etShippingTotal() {
        if (this.order.etShippingTotal === null) {
          return 0
        }
        
        return this.order.etShippingTotal
      },
      discount() {
        if (this.order.discount === null) {
          return 0
        }
        
        return this.order.discount
      },
      etTotal() {
        if (this.order.etTotal === null) {
          return 0
        }
        
        return this.order.etTotal
      },
      statusName() {
        if (this.order.status) {
          return this.order.status.name
        }

        return ''
      },
      statusColor() {
        if (this.order.status) {
          return this.order.status.color
        }

        return '#000000'
      },
      expectedDelivery() {
        if (this.order.expectedDelivery) {
          return this.order.expectedDelivery.formatted
        }

        return ''
      },
      shippingAddress() {
        if (this.order.shippingAddress) {
          return this.order.shippingAddress
        }

        return {}
      },
      billingAddress() {
        if (this.order.billingAddress) {
          return this.order.billingAddress
        }

        return {}
      }
    },

    mounted() {
      let title = document.title.replace('__orderNumber__', this.id)
      document.title = title
    },

    created() {
      EventBus.$emit(LOADING, 'Chargement de la commande')
      this.id = this.$route.params.id
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'referer')) {
        this.referer = this.$route.params.referer
      }
      this.getOrder(this.id)
    },
  }
</script>

<style scoped>
  .v-chip.outlined {
    border: 1px solid #333 !important;
  }
  .histories-items::last-child {
    margin-bottom: 10px !important;
  }
  .inline-block {
    display: inline-block !important;
  }
</style>